﻿import { PositionDateField } from '../enums/index';

export interface IUpdatePositionDateTime {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    whichDate: PositionDateField;
    dateTimeValue: string;
    isLoop: boolean
}
